<template>
    <div>
        <el-form style="float:left;width: 100%" :model="queryParams" :rules="queryParamsRules" ref="paramsForm">
            <el-form-item style="display:inline-block;margin-right: 10px" prop="baseType">
                <el-select v-model="queryParams.baseType">
                    <el-option value="USDT" label="USDT合约"></el-option>
                    <el-option value="COIN" label="币本位合约"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="display:inline-block;margin-right: 10px" prop="limit">
                <el-select v-model="queryParams.limit">
                    <el-option :value="10" label="10条数据"></el-option>
                    <el-option :value="20" label="20条数据"></el-option>
                    <el-option :value="50" label="50条数据"></el-option>
                    <el-option :value="100" label="100条数据"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="display:inline-block;margin-right: 10px" prop="userId">
                <el-input v-model="queryParams.userId" placeholder="用户ID" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item style="display:inline-block;margin-right: 10px">
                <el-input v-model="queryParams.symbol" placeholder="交易对" style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item style="display:inline-block;margin-right: 10px">
                <el-input v-model="queryParams.pair" placeholder="标的交易对" style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item style="display:inline-block;margin-right: 10px">
                <el-date-picker v-model="dateArr" type="datetimerange" range-separator="至" @change="dateChange"
                                start-placeholder="起始时间" end-placeholder="结束时间" align="right" value-format="timestamp">
                </el-date-picker>
            </el-form-item>
            <el-button type="primary" @click="getUserTrades">搜 索</el-button>
            <span style="color: red"> * 交易对和标的交易对只能填其中一个，且必传</span>
        </el-form>

        <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 20px"
                  :data="dataList" :row-key="() => Math.random()">
            <el-table-column prop="id" label="交易ID" show-overflow-tooltip></el-table-column>
            <el-table-column prop="orderId" label="订单ID" show-overflow-tooltip></el-table-column>
            <el-table-column prop="symbol" label="交易对" show-overflow-tooltip></el-table-column>
            <el-table-column prop="pair" label="标的交易对" show-overflow-tooltip></el-table-column>
            <el-table-column prop="side" label="买卖方向" show-overflow-tooltip></el-table-column>
            <el-table-column prop="price" label="成交价" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qty" label="成交量(张数)" show-overflow-tooltip></el-table-column>
            <el-table-column prop="realizedPnl" label="实现盈亏" show-overflow-tooltip></el-table-column>
            <el-table-column prop="marginAsset" label="保证金币种" show-overflow-tooltip></el-table-column>
            <el-table-column prop="baseQty" label="成交额(标的数量)" show-overflow-tooltip></el-table-column>
            <el-table-column prop="commission" label="手续费" show-overflow-tooltip></el-table-column>
            <el-table-column prop="commissionAsset" label="手续费单位" show-overflow-tooltip></el-table-column>
            <el-table-column prop="positionSide" label="持仓方向" show-overflow-tooltip></el-table-column>
            <el-table-column prop="buyer" label="是否是买方" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-switch :value="scope.row.buyer" active-color="#13ce66" inactive-color="#ff4949" :disabled="true"></el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="maker" label="是否是挂单方" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-switch :value="scope.row.maker" active-color="#13ce66" inactive-color="#ff4949" :disabled="true"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="时间">
                <template slot-scope="scope">
                    <span>{{scope.row.time | moment}}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import "../../store";
    import api from "../../api";

    export default {
        name: "TransactionRecord",
        data() {
            return {
                dataList:[],
                queryParams: {
                    baseType: "USDT",
                    userId: "",
                    symbol: "",
                    pair: "",
                    startTime: "",
                    endTime: "",
                    limit: 50
                },
                queryParamsRules: {
                    "baseType": [{required: true, message: "类型不能为空"}],
                    "userId": [{required: true, message: "用户ID不能为空"}],
                    "limit": [{required: true, message: "结果条数不能为空"}],
                },
                dateArr: []
            };
        },
        methods: {
            dateChange() {
                this.queryParams.startTime = this.dateArr ? this.dateArr[0] : null;
                this.queryParams.endTime = this.dateArr ? this.dateArr[1] : null;
            },
            getUserTrades() {
                this.$refs["paramsForm"].validate(valid => {
                    if (valid) {
                        api.getUserTrades(this.queryParams).then(({data}) => {
                            this.dataList = data;
                        });
                    }
                });
            },
        },
        created() {
        },
    };
</script>

<style lang="less" scoped>

</style>